import { HeartMultipleIcon } from './HeartMultipleIcon';

/**
 * author: Michael Irigoyen
 * id BDAF5217-358E-4673-BF16-FFFBD09EAD8F
 * name heart-multiple
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/heart-multiple.svg
 * tags
 */
export const HeartsIcon = HeartMultipleIcon;
export default HeartsIcon